import {BASE_ADMIN_API, fetchAPI} from '@/services/api';
import {UserInfo} from "@/store/admin/userInfo";
import {ResponsePage, RequestPage} from '@/services/page.interface';
import MD5 from 'crypto-js/md5';

export interface QueryUserPage extends RequestPage {
    deptId?: number;
    username?: string;
    firstName?: string;
}

export interface UserPageData {
    records: UserInfo[];
    total: number;
    pageNum: number;
    pageSize: number;
}

const defaultUrl = BASE_ADMIN_API + '/user';

// 创建用户
export async function createUser(user: Partial<UserInfo>) {
    return fetchAPI<UserInfo>(`${defaultUrl}/createUser`, {
        method: 'POST',
        body: JSON.stringify(user),
        headers: {'Content-Type': 'application/json'},
    });
}

export async function resetPassword(userId: number) {
    // Backend expects @RequestParam("userId") in the query string
    return fetchAPI<Record<number, string>>(`${defaultUrl}/resetPassword?userId=${userId}`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
    });
}

export type ChangePasswordParams = {
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
};

export async function changePassword(params: ChangePasswordParams) {
    const encryptedParams: ChangePasswordParams = {
        oldPassword: MD5(params.oldPassword).toString(),
        newPassword: MD5(params.newPassword).toString(),
        confirmPassword: MD5(params.confirmPassword).toString(),
    };
    return fetchAPI<void>(`${defaultUrl}/changePassword`, {
        method: 'POST',
        body: JSON.stringify(encryptedParams),
        headers: {'Content-Type': 'application/json'},
    });
}

export async function queryUnactivatedUser(queryPage: QueryUserPage = {pageSize: 10, pageNumber: 1, pageType: 1}) {
    return fetchAPI<UserInfo>(`${defaultUrl}/queryUnactivatedUser`, {
        method: 'POST',
        body: JSON.stringify(queryPage),
        headers: {'Content-Type': 'application/json'},
    });
}

export async function activatedAccount(userIds: number[]) {
    return fetchAPI<UserInfo>(`${defaultUrl}/activatedAccount`, {
        method: 'POST',
        body: JSON.stringify({userIds}),
        headers: {'Content-Type': 'application/json'},
    });
}

// 更新用户
export async function updateUser(userId: number, user: Partial<UserInfo>) {
    return fetchAPI<UserInfo>(`${defaultUrl}/updateUser/${userId}`, {
        method: 'POST',
        body: JSON.stringify(user),
        headers: {'Content-Type': 'application/json'},
    });
}

// 删除用户
export async function deleteUser(userId: number) {
    return fetchAPI<any>(`${defaultUrl}/deleteUser/${userId}`, {
        method: 'POST',
    });
}

// 根据ID获取用户
export async function getUserById(userId: number) {
    return fetchAPI<UserInfo>(`${defaultUrl}/getUserById/${userId}`, {
        method: 'GET',
    });
}

export async function queryUsersByDeptIds(deptId: number) {
    return fetchAPI<[]>(`${defaultUrl}/queryUsersByDeptIds/${deptId}`, {
        method: 'POST'
    });
}

export async function queryUsersMsgByDeptId(deptId: number) {
    return fetchAPI<[]>(`${defaultUrl}/queryUsersMsgByDeptId/${deptId}`, {
        method: 'POST'
    });
}

export async function queryUserPage(queryPage: QueryUserPage = {pageSize: 20, pageNumber: 1, pageType: 1}) {
    return fetchAPI<ResponsePage<UserInfo>>(`${defaultUrl}/queryUserPage`, {
        method: 'POST',
        body: JSON.stringify(queryPage)
    });
}

// 查询当前登录用户
export async function queryLoginUser() {
    return fetchAPI<UserInfo>(`${defaultUrl}/queryLoginUser`, {
        method: 'POST',
    });
}
